module.exports = __webpack_public_path__ + "bg-02.e331bc52caf9796eec96.jpg";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/img/bg-02.jpg
// module id = ../../../../../src/assets/img/bg-02.jpg
// module chunks = main